/* eslint-disable prefer-regex-literals */
export default class Contract {
  constructor() {
    this.errors = []
  }

  isRequired(value, message) {
    if (!value || value.length <= 0) {
      this.errors.push(message)
    }
  }

  hasMinLen(value, min, message) {
    if (!value || value.length < min) {
      this.errors.push(message)
    }
  }

  hasMaxLen(value, max, message) {
    if (!value || value.length > max) {
      this.errors.push(message)
    }
  }

  isFixedLen(value, len, message) {
    if (value.length !== len) {
      this.errors.push(message)
    }
  }

  isEmail(value, message) {
    const reg = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    if (!reg.test(value)) {
      this.errors.push(message)
    }
  }

  isCep(value, message) {
    const reg = new RegExp(/^\d{5} - \d{3}$/)
    if (!reg.test(value)) {
      this.errors.push(message)
    }
  }

  isPhone(value, message) {
    const reg = new RegExp(
      /(?:\+?55\s?)?(?:\(?\d{2}\)?[-\s]?)?\d{4,5}[-\s]?\d{4}/g
    )
    if (!reg.test(value)) {
      this.errors.push(message)
    }
  }

  isCpf(value, message) {
    const reg = new RegExp(/^\d{3}\.\d{3}.\d{3}-\d{2}$/g)
    if (!reg.test(value)) {
      this.errors.push(message)
    }
  }

  isHTML(value, message) {
    const reg = new RegExp(/<\/?[\w\s="']+\/?>/gi)
    if (!reg.test(value)) { this.errors.push(message) }
  }

  validateCpf(value, message) {
    let sum = 0
    let rest = 0
    const newValue = value.replace(/\D/g, '')
    if (
      newValue === '00000000000' ||
      newValue === '11111111111' ||
      newValue === '22222222222' ||
      newValue === '33333333333' ||
      newValue === '44444444444' ||
      newValue === '55555555555' ||
      newValue === '66666666666' ||
      newValue === '77777777777' ||
      newValue === '88888888888' ||
      newValue === '99999999999'
    ) {
      this.errors.push(message)
    }
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(newValue.substring(i - 1, i)) * (11 - i)
    }
    rest = (sum * 10) % 11
    if (rest === 10 || rest === 11) rest = 0
    if (rest !== parseInt(newValue.substring(9, 10))) {
      return this.errors.push(message)
    }
    sum = 0
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(newValue.substring(i - 1, i)) * (12 - i)
    }
    rest = (sum * 10) % 11
    if (rest === 10 || rest === 11) rest = 0
    if (rest !== parseInt(newValue.substring(10, 11))) {
      return this.errors.push(message)
    }
  }

  validateCNPJ(value, message) {
    value = value.replace(/[^\d]+/g, '')
    const validTypes =
      typeof value === 'string' ||
      Number.isInteger(value) ||
      Array.isArray(value)

    // Elimina valor em formato inválido
    if (!validTypes) return this.errors.push(message)

    // Guarda um array com todos os dígitos do valor
    const match = value.toString().match(/\d/g)
    const numbers = Array.isArray(match) ? match.map(Number) : []

    // Valida a quantidade de dígitos
    if (numbers.length !== 14) return this.errors.push(message)

    // Elimina inválidos com todos os dígitos iguais
    const items = [...new Set(numbers)]
    if (items.length === 1) return this.errors.push(message)

    // Cálculo validador
    const calc = (x) => {
      const slice = numbers.slice(0, x)
      let factor = x - 7
      let sum = 0

      for (let i = x; i >= 1; i--) {
        const n = slice[x - i]
        sum += n * factor--
        if (factor < 2) factor = 9
      }

      const result = 11 - (sum % 11)

      return result > 9 ? 0 : result
    }

    // Separa os 2 últimos dígitos de verificadores
    const digits = numbers.slice(12)

    // Valida 1o. dígito verificador
    const digit0 = calc(12)
    if (digit0 !== digits[0]) return this.errors.push(message)

    // Valida 2o. dígito verificador
    const digit1 = calc(13)
    return digit1 === digits[1]
  }

  clear() {
    this.errors = []
  }

  isValid() {
    return this.errors.length === 0
  }
}
